import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  AUTH_ASYNC_CALL_START,
  AUTH_ASYNC_CALL_END,
  RESET_PASSWORD_BY_SMS_SUCCESS,
} from '../actions/actions'

export default function auth(state = {}, action) {
  switch (action.type) {
    case AUTH_ASYNC_CALL_START:
      return { ...state, aSyncCall: true }

    case AUTH_ASYNC_CALL_END:
      return { ...state, aSyncCall: false }

    case LOGIN_SUCCESS:
      return {
        authenticated: true,
        userType: action.userType ? action.userType.toUpperCase() : undefined,
        token: action.token,
        userId: action.userId,
        email: action.email,
        username: action.username,
      }

    // this is actually never used, LOGOUT_SUCCESS is
    // handled by a higher order reducer that wraps all reducers
    case LOGOUT_SUCCESS:
      return {
        authenticated: false,
        userType: undefined,
        token: undefined,
        userId: undefined,
        email: undefined,
        username: undefined,
      }

    case RESET_PASSWORD_BY_SMS_SUCCESS:
      const { resetData } = action
      return { ...state, resetData }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js